<template>
  <modal
      :height="600"
      :width="400"
  >
    <div
        class="container"
        @click.stop
    >
      <h3 class="">Nawigacja</h3>
      <hr/>
      <div v-if="isAdmin">
        <custom-radio
          class="radio-section py-2"
          :initial-value="selectedOption"
          :options="options"
          @radioChange="changeDailyValue"
        />
        <custom-select
          v-if="!daily"
          class="select-box"
          :options="trainers"
          label="full_name"
          :selected-value="selectedTrainerId"
          @new-selected="changeSelectedTrainer"
        />
      </div>
      <div class="d-flex justify-content-center">
        <picker
          :model-value="selectedDate"
          v-bind="$attrs"
          @update:modelValue="newDate"
      />
      </div>
      <div class="d-flex justify-content-between pt-5">
        <div>
          <custom-button
            class="accept-button"
            button-name="Zamknij"
            @click="$emit('closeNavigationModal')"
          />
        </div>
        <div>
          <custom-button
            class="accept-button"
            button-name="Wyloguj"
            @click="logout"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { computed, ref } from 'vue';

import axios from 'axios';
import store from '@/store';

import { urlBuilder } from '@/plugins/helpers';
import { logout } from '../../plugins/auth';

import CustomButton from '../common/CustomButton.vue';
import CustomRadio from '../common/CustomRadio.vue';
import Modal from './Modal.vue';
import Picker from '../calendar/Picker.vue';
import CustomSelect from '../common/CustomSelect.vue';

export default {
  name: 'navigation-modal',

  components: {
    CustomSelect, CustomRadio, CustomButton, Picker, Modal,
  },

  emits: ['closeNavigationModal', 'newDate'],

  props: {
    date: Object,
  },

  setup(props, { emit }) {
    const options = [
      {
        value: true,
        label: 'Widok dobowy',
      },
      {
        value: false,
        label: 'Widok tygodniowy',
      },
    ];
    const selectedTrainerId = computed(() => store.getters.selectedTrainerId);

    const isAdmin = computed(() => store.getters.isAdmin);

    const daily = computed(() => store.getters.daily);

    const trainers = ref([]);

    function changeDailyValue(e) {
      store.dispatch('saveDaily', e);
      if (!selectedTrainerId.value) store.dispatch('saveSelectedTrainerId', trainers.value[0].id);
      else if (!e) store.dispatch('saveSelectedTrainerId', store.getters.trainerId);
      else store.dispatch('saveSelectedTrainerId', null);
    }

    const selectedOption = computed(() => {
      if (daily.value) return options[0].value;
      return options[1].value;
    });

    async function getTrainers() {
      trainers.value = (await axios.get(urlBuilder('/trainers/'))).data;
    }

    getTrainers();

    function changeSelectedTrainer(e) {
      store.dispatch('saveSelectedTrainerId', e);
    }

    const selectedDate = ref(props.date.format('DD-MM-YYYY'));

    function newDate(event) {
      emit('newDate', event);
    }

    return {
      changeDailyValue,
      changeSelectedTrainer,
      daily,
      isAdmin,
      trainers,
      logout,
      newDate,
      options,
      selectedDate,
      selectedOption,
      selectedTrainerId,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .radio-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .select-box {
    margin-bottom: 20px;
    width: 200px;
  }
}

.accept-button {
  background-color: $blue;
  border-radius: 5px;
  border: 1px solid $blue;
  color: $white;
  height: 30px;
  width: 100px;
}

</style>
